/**
 * Normalize FastAPI HTTPException detail for display (string | array | object).
 */
export function formatFastApiDetail(detail) {
  if (detail == null || detail === '') return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (typeof e === 'object' && e != null ? e.msg || e.message || JSON.stringify(e) : String(e)))
      .filter(Boolean)
      .join('；');
  }
  if (typeof detail === 'object') {
    return detail.message || detail.msg || JSON.stringify(detail);
  }
  return String(detail);
}
